import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Apps.css";
import Response_Processing from "../../../layout/Others/Response_Processing";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import { RiLockPasswordLine } from "react-icons/ri";
import { TbEyeClosed } from "react-icons/tb";
import { VscEye } from "react-icons/vsc";
import { IoMdInformationCircle } from "react-icons/io";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { FaAndroid, FaDownload, FaBoxOpen, FaBug, FaCheckCircle } from "react-icons/fa";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";


function Apps() {
    const baseURL = process.env.BASE_URL;

    const { fetchRequest, globalImageUplaodAPI } = useMyContext()
    const [showOverlay, setShowOverlay] = useState(false);
    const [appMappings, setAppMappings] = useState([]);
    const [passwordType, setPasswordType] = useState("password");
    const [appUrl, setAppUrl] = useState('');
    const [appPassword, setAppPassword] = useState('');
    const authToken = "85547cae-8a0b-11ef-935e-c809a8d34fa9"
    const [formData, setFormData] = useState({
        API_URL: "",
        authToken: ""
    });

    const [formDataError, setFormDataError] = useState({
        API_URL: "",
        authToken: ""
    });

    const [appForm, setAppForm] = useState({
        app_name: "",
        package_name: "",
        app_icon: null,
    });

    const [appFormApp, setAppFormApp] = useState({
        app_name: "",
        package_name: "",
        app_icon: null,

        buildtype: "0",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: null,
        key_password: "",
        key_store_password: "",
        appformat: "0",
        google_json: null,
        with_jks: "0",
    });

    const [formErrorsApp, setFormErrorsApp] = useState({
        app_name: "",
        package_name: "",
        app_icon: "",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: "",
        key_password: "",
        key_store_password: "",
        google_json: "",
    });

    const [appFormTV, setAppFormTV] = useState({
        app_name: "",
        package_name: "",
        app_icon: null,
        buildtype: "0",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: null,
        key_password: "",
        key_store_password: "",
        appformat: "0",
        google_json: null,
        with_jks: "0",
    });

    const [formErrorsTV, setFormErrorsTV] = useState({
        app_name: "",
        package_name: "",
        app_icon: "",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: "",
        key_password: "",
        key_store_password: "",
        google_json: "",
    });

    const [appFormFireTV, setAppFormFireTV] = useState({
        app_name: "",
        package_name: "",
        app_icon: null,
        buildtype: "0",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: null,
        key_password: "",
        key_store_password: "",
        appformat: "0",
        google_json: null,
        with_jks: "0",
    });

    const [formErrorsFireTV, setFormErrorsFireTV] = useState({
        app_name: "",
        package_name: "",
        app_icon: "",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: "",
        key_password: "",
        key_store_password: "",
        google_json: "",
    });

    const [appFormLGTV, setAppFormLGTV] = useState({
        app_name: "",
        package_name: "",
        app_icon: null,
        buildtype: "0",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: null,
        key_password: "",
        key_store_password: "",
        appformat: "0",
        google_json: null,
        with_jks: "0",
    });

    const [formErrorsLGTV, setFormErrorsLGTV] = useState({
        app_name: "",
        package_name: "",
        app_icon: "",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: "",
        key_password: "",
        key_store_password: "",
        google_json: "",
    });

    const [appFormSamsung, setAppFormSamsung] = useState({
        app_name: "",
        package_name: "",
        app_icon: null,
        buildtype: "0",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: null,
        key_password: "",
        key_store_password: "",
        appformat: "0",
        google_json: null,
        with_jks: "0",
    });

    const [formErrorsSamsung, setFormErrorsSamsung] = useState({
        app_name: "",
        package_name: "",
        app_icon: "",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: "",
        key_password: "",
        key_store_password: "",
        google_json: "",
    });

    const [appFormRoku, setAppFormRoku] = useState({
        app_name: "",
        package_name: "",
        app_icon: null,
        buildtype: "0",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: null,
        key_password: "",
        key_store_password: "",
        appformat: "0",
        google_json: null,
        with_jks: "0",
    });

    const [formErrorsRoku, setFormErrorsRoku] = useState({
        app_name: "",
        package_name: "",
        app_icon: "",
        client: "",
        version_code: "",
        version_name: "",
        jksfile: "",
        key_password: "",
        key_store_password: "",
        google_json: "",
    });

    const validateImageSize = (file, setErrors) => {
        if (!file) return;
        const img = new Image();
        img.onload = () => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            if (width !== 512 || height !== 512) {
                setErrors((prev) => ({ ...prev, app_icon: `App icon must be exactly 512 x 512 pixels. (Detected: ${width}x${height}px)` }));
            } else {
                setErrors((prev) => ({ ...prev, app_icon: "" }));
            }
            URL.revokeObjectURL(img.src);
        };
        img.onerror = () => {
            setErrors((prev) => ({ ...prev, app_icon: "Invalid image file or format." }));
            URL.revokeObjectURL(img.src);
        };
        img.src = URL.createObjectURL(file);
    };

    const handleInputApp = (e) => {
        const { name, value, type, files, checked } = e.target;
        if (name === "app_name" && /\d/.test(value)) return;
        if (name === "package_name" && /\d/.test(value)) return;
        if (name === "version_code" && value !== "" && !/^\d+$/.test(value)) return;
        if (name === "version_name" && value !== "" && !/^[\d.]+$/.test(value)) return;
        if (type === "file") {
            const file = files[0];
            setAppFormApp((prev) => ({ ...prev, [name]: file }));
            setFormErrorsApp((prev) => ({ ...prev, [name]: "" }));
            if (name === "app_icon") validateImageSize(file, setFormErrorsApp);
            return;
        }
        if (type === "checkbox") {
            setAppFormApp((prev) => ({ ...prev, [name]: checked ? "1" : "0" }));
            setFormErrorsApp((prev) => ({ ...prev, [name]: "" }));
            return;
        }
        setAppFormApp((prev) => ({ ...prev, [name]: value }));
        setFormErrorsApp((prev) => ({ ...prev, [name]: "" }));
    };

    const handleInputTV = (e) => {
        const { name, value, type, files, checked } = e.target;
        if (name === "app_name" && /\d/.test(value)) return;
        if (name === "package_name" && /\d/.test(value)) return;
        if (name === "version_code" && value !== "" && !/^\d+$/.test(value)) return;
        if (name === "version_name" && value !== "" && !/^[\d.]+$/.test(value)) return;
        if (type === "file") {
            const file = files[0];
            setAppFormTV((prev) => ({ ...prev, [name]: file }));
            setFormErrorsTV((prev) => ({ ...prev, [name]: "" }));
            if (name === "app_icon") validateImageSize(file, setFormErrorsTV);
            return;
        }
        if (type === "checkbox") {
            setAppFormTV((prev) => ({ ...prev, [name]: checked ? "1" : "0" }));
            setFormErrorsTV((prev) => ({ ...prev, [name]: "" }));
            return;
        }
        setAppFormTV((prev) => ({ ...prev, [name]: value }));
        setFormErrorsTV((prev) => ({ ...prev, [name]: "" }));
    };

    const handleInputFireTV = (e) => {
        const { name, value, type, files, checked } = e.target;
        if (name === "app_name" && /\d/.test(value)) return;
        if (name === "package_name" && /\d/.test(value)) return;
        if (name === "version_code" && value !== "" && !/^\d+$/.test(value)) return;
        if (name === "version_name" && value !== "" && !/^[\d.]+$/.test(value)) return;
        if (type === "file") {
            const file = files[0];
            setAppFormFireTV((prev) => ({ ...prev, [name]: file }));
            setFormErrorsFireTV((prev) => ({ ...prev, [name]: "" }));
            if (name === "app_icon") validateImageSize(file, setFormErrorsFireTV);
            return;
        }
        if (type === "checkbox") {
            setAppFormFireTV((prev) => ({ ...prev, [name]: checked ? "1" : "0" }));
            setFormErrorsFireTV((prev) => ({ ...prev, [name]: "" }));
            return;
        }
        setAppFormFireTV((prev) => ({ ...prev, [name]: value }));
        setFormErrorsFireTV((prev) => ({ ...prev, [name]: "" }));
    };

    const handleInputLGTV = (e) => {
        const { name, value, type, files, checked } = e.target;
        if (name === "app_name" && /\d/.test(value)) return;
        if (name === "package_name" && /\d/.test(value)) return;
        if (name === "version_code" && value !== "" && !/^\d+$/.test(value)) return;
        if (name === "version_name" && value !== "" && !/^[\d.]+$/.test(value)) return;
        if (type === "file") {
            const file = files[0];
            setAppFormLGTV((prev) => ({ ...prev, [name]: file }));
            setFormErrorsLGTV((prev) => ({ ...prev, [name]: "" }));
            if (name === "app_icon") validateImageSize(file, setFormErrorsLGTV);
            return;
        }
        if (type === "checkbox") {
            setAppFormLGTV((prev) => ({ ...prev, [name]: checked ? "1" : "0" }));
            setFormErrorsLGTV((prev) => ({ ...prev, [name]: "" }));
            return;
        }
        setAppFormLGTV((prev) => ({ ...prev, [name]: value }));
        setFormErrorsLGTV((prev) => ({ ...prev, [name]: "" }));
    };

    const handleInputSamsung = (e) => {
        const { name, value, type, files, checked } = e.target;
        if (name === "app_name" && /\d/.test(value)) return;
        if (name === "package_name" && /\d/.test(value)) return;
        if (name === "version_code" && value !== "" && !/^\d+$/.test(value)) return;
        if (name === "version_name" && value !== "" && !/^[\d.]+$/.test(value)) return;
        if (type === "file") {
            const file = files[0];
            setAppFormSamsung((prev) => ({ ...prev, [name]: file }));
            setFormErrorsSamsung((prev) => ({ ...prev, [name]: "" }));
            if (name === "app_icon") validateImageSize(file, setFormErrorsSamsung);
            return;
        }
        if (type === "checkbox") {
            setAppFormSamsung((prev) => ({ ...prev, [name]: checked ? "1" : "0" }));
            setFormErrorsSamsung((prev) => ({ ...prev, [name]: "" }));
            return;
        }
        setAppFormSamsung((prev) => ({ ...prev, [name]: value }));
        setFormErrorsSamsung((prev) => ({ ...prev, [name]: "" }));
    };

    const handleInputRoku = (e) => {
        const { name, value, type, files, checked } = e.target;
        if (name === "app_name" && /\d/.test(value)) return;
        if (name === "package_name" && /\d/.test(value)) return;
        if (name === "version_code" && value !== "" && !/^\d+$/.test(value)) return;
        if (name === "version_name" && value !== "" && !/^[\d.]+$/.test(value)) return;
        if (type === "file") {
            const file = files[0];
            setAppFormRoku((prev) => ({ ...prev, [name]: file }));
            setFormErrorsRoku((prev) => ({ ...prev, [name]: "" }));
            if (name === "app_icon") validateImageSize(file, setFormErrorsRoku);
            return;
        }
        if (type === "checkbox") {
            setAppFormRoku((prev) => ({ ...prev, [name]: checked ? "1" : "0" }));
            setFormErrorsRoku((prev) => ({ ...prev, [name]: "" }));
            return;
        }
        setAppFormRoku((prev) => ({ ...prev, [name]: value }));
        setFormErrorsRoku((prev) => ({ ...prev, [name]: "" }));
    };


    const access_token = localStorage.getItem("access_token");

    const headers = {
        Authorization: `Bearer ${access_token}`,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
    };


    const getAppMappings = () => {
        axios
            .get(`${process.env.REACT_APP_Baseurl}/admin/app-build/index`, { headers })
            .then((response) => {
                const configArray = response.data.app_config || [];

                const appUrlObj = configArray.find(item => item.app_url);
                const appPasswordObj = configArray.find(item => item.app_password);

                if (appUrlObj?.app_url) {
                    setAppUrl(appUrlObj.app_url);
                }

                if (appPasswordObj?.app_password) {
                    setAppPassword(appPasswordObj.app_password);
                }

                if (response.data.status_code === 200) {
                    setAppMappings(response.data.AppBuild_Settings);
                } else {
                    console.warn("No mappings found:", response.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching app mappings:", error);
            });
    }

    useEffect(() => {
        getAppMappings();
    }, []);



    const togglePassword = () => {
        setPasswordType(prevType => (prevType === "password" ? "text" : "password"));
    };

    const validatePackageName = (packageName) => {
        if (!packageName?.trim()) return "Package name is required.";
        const dotCount = (packageName.match(/\./g) || []).length;
        if (dotCount < 2) return "Package name must contain at least 2 dots (e.g. com.organisation.appname).";
        return "";
    };

    // App
    const handleSubmitApp = async (e) => {

        e.preventDefault();
        const errors = {};
        let valid = true;

        const pkgError = validatePackageName(appFormApp.package_name);
        if (pkgError) { errors.package_name = pkgError; valid = false; }

        const validations = [
            { key: "app_name", check: appFormApp.app_name?.trim(), message: "App name is required." },
            { key: "app_icon", check: appFormApp.app_icon instanceof File, message: "App icon is required." },
            { key: "client", check: appFormApp.client?.trim(), message: "Client name is required." },
        ];

        if (Number(appFormApp.appformat) === 1) {
            validations.push(
                { key: "version_code", check: appFormApp.version_code, message: "Version code is required." },
                { key: "version_name", check: appFormApp.version_name?.trim(), message: "Version name is required." },
            );
        }

        validations.push(
            { key: "key_password", check: appFormApp.key_password, message: "Key password is required." },
            { key: "key_store_password", check: appFormApp.key_store_password, message: "Keystore password is required." }
        );

        if (appFormApp.with_jks === "1") {
            validations.push(
                { key: "jksfile", check: appFormApp.jksfile instanceof File, message: "JKS file is required." },
            );
        }


        validations.forEach(({ key, check, message }) => {
            if (!check) {
                errors[key] = message;
                valid = false;
            }
        });

        if (!valid) {
            setFormErrorsApp(errors);
            return;
        }

        try {
            setShowOverlay(true);
            toast.info("Processing app download...");
            const buildFormData = new FormData();
            buildFormData.append("authToken", authToken);
            buildFormData.append("apptype", "1");
            buildFormData.append("appformat", appFormApp.appformat);
            buildFormData.append("app_icon", appFormApp.app_icon);
            buildFormData.append("appname", appFormApp.app_name);
            buildFormData.append("packagename", appFormApp.package_name);
            buildFormData.append("apiurl", appUrl);
            buildFormData.append("buildtype", appFormApp.buildtype);
            buildFormData.append("client", appFormApp.client);

            buildFormData.append("google_json", appFormApp.google_json);
            buildFormData.append("with_jks", appFormApp.with_jks);

            if (Number(appFormApp.appformat) === 1) {
                buildFormData.append("version_code", appFormApp.version_code);
                buildFormData.append("version_name", appFormApp.version_name);
            }
            buildFormData.append("key_password", appFormApp.key_password);
            buildFormData.append("key_store_password", appFormApp.key_store_password);

            if (appFormApp.with_jks === "1") {
                buildFormData.append("jksfile", appFormApp.jksfile);
            }
            const buildResponse = await axios.post(`${process.env.REACT_APP_Deployment_APP_URL}/admin-flicknexs/build-app`, buildFormData, { headers });
            const downloadUrl = buildResponse?.data?.result;
            if (!downloadUrl) throw new Error("Download URL is missing.");

            const storeFormData = new FormData();
            storeFormData.append("authToken", authToken);
            storeFormData.append("apptype", "1");
            storeFormData.append("buildtype", "1");
            storeFormData.append("appformat", appFormApp.appformat);
            storeFormData.append("app_name", appFormApp.app_name);
            storeFormData.append("package_name", appFormApp.package_name);
            storeFormData.append("build_url", downloadUrl);
            storeFormData.append("api_url", appUrl);
            storeFormData.append("apk_build_type", "Android App");
            storeFormData.append("client", appFormApp.client);

            storeFormData.append("google_json", appFormApp.google_json ? appFormApp.google_json.name : "");
            storeFormData.append("with_jks", appFormApp.with_jks);

            if (Number(appFormApp.appformat) === 1) {
                storeFormData.append("version_code", appFormApp.version_code);
                storeFormData.append("version_name", appFormApp.version_name);
            }
            storeFormData.append("key_password", appFormApp.key_password);
            storeFormData.append("key_store_password", appFormApp.key_store_password);

            if (appFormApp.with_jks === "1") {
                storeFormData.append("jksfile", appFormApp.jksfile ? appFormApp.jksfile.name : "");
            }
            const storeResponse = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/app-build/store`, storeFormData, { headers });
            if (storeResponse.data.status_code !== 200) {
                throw new Error("Failed to store app data.");
            }

            // Guaranteed list refresh after successful store
            getAppMappings();

            // Isolated Image Upload
            if (appFormApp.app_icon) {
                try {
                    const imageFormData = new FormData();
                    imageFormData.append("id", storeResponse.data.data.id);
                    imageFormData.append("modelName", "AdminAppBuildSetting");
                    imageFormData.append("app_icon", appFormApp.app_icon);
                    imageFormData.append("imageFields[]", "app_icon");
                    const imageResponse = await axios.post(globalImageUplaodAPI(), imageFormData, { headers });
                } catch (imgError) {
                    console.error("Image upload error:", imgError);
                    toast.warn("App icon upload failed, but build record was saved.");
                }
            }
            toast.success("App build process completed and data saved successfully!");

        } catch (error) {
            console.error("Store App Build Error:", error);
            const errorMessage = error.response?.data?.message || "An error occurred while processing the app build.";
            toast.error(errorMessage);
        } finally {
            setShowOverlay(false);
        }
    };


    // Tv
    const handleSubmitTV = async (e) => {
        e.preventDefault();
        const errors = {};
        let valid = true;

        const pkgErrorTV = validatePackageName(appFormTV.package_name);
        if (pkgErrorTV) { errors.package_name = pkgErrorTV; valid = false; }

        const validations = [
            { key: "app_name", check: appFormTV.app_name?.trim(), message: "App name is required." },
            { key: "app_icon", check: appFormTV.app_icon instanceof File, message: "App icon is required." },
            { key: "client", check: appFormTV.client?.trim(), message: "Client name is required." },
        ];

        if (Number(appFormTV.appformat) === 1) {
            validations.push(
                { key: "version_code", check: appFormTV.version_code, message: "Version code is required." },
                { key: "version_name", check: appFormTV.version_name?.trim(), message: "Version name is required." },
            );
        }

        validations.push(
            { key: "key_password", check: appFormTV.key_password, message: "Key password is required." },
            { key: "key_store_password", check: appFormTV.key_store_password, message: "Keystore password is required." }
        );

        if (appFormTV.with_jks === "1") {
            validations.push(
                { key: "jksfile", check: appFormTV.jksfile instanceof File, message: "JKS file is required." },
            );
        }

        validations.forEach(({ key, check, message }) => {
            if (!check) {
                errors[key] = message;
                valid = false;
            }
        });

        if (!valid) {
            setFormErrorsTV(errors);
            return;
        }

        try {
            setShowOverlay(true);
            toast.info("Processing app download...");
            const buildFormData = new FormData();
            buildFormData.append("authToken", authToken);
            buildFormData.append("apptype", "2");
            buildFormData.append("appformat", appFormTV.appformat);
            buildFormData.append("app_icon", appFormTV.app_icon);
            buildFormData.append("appname", appFormTV.app_name);
            buildFormData.append("packagename", appFormTV.package_name);
            buildFormData.append("apiurl", appUrl);
            buildFormData.append("buildtype", appFormTV.buildtype);
            buildFormData.append("client", appFormTV.client);

            buildFormData.append("google_json", appFormTV.google_json);
            buildFormData.append("with_jks", appFormTV.with_jks);

            if (Number(appFormTV.appformat) === 1) {
                buildFormData.append("version_code", appFormTV.version_code);
                buildFormData.append("version_name", appFormTV.version_name);
            }
            buildFormData.append("key_password", appFormTV.key_password);
            buildFormData.append("key_store_password", appFormTV.key_store_password);

            if (appFormTV.with_jks === "1") {
                buildFormData.append("jksfile", appFormTV.jksfile);
            }

            const buildResponse = await axios.post(`${process.env.REACT_APP_Deployment_APP_URL}/admin-flicknexs/build-app`, buildFormData, { headers });
            const downloadUrl = buildResponse?.data?.result;
            if (!downloadUrl) throw new Error("Download URL is missing.");

            const storeFormData = new FormData();
            storeFormData.append("authToken", authToken);
            storeFormData.append("apptype", "2");
            storeFormData.append("buildtype", "1");
            storeFormData.append("appformat", appFormTV.appformat);
            storeFormData.append("app_name", appFormTV.app_name);
            storeFormData.append("package_name", appFormTV.package_name);
            storeFormData.append("build_url", downloadUrl);
            storeFormData.append("api_url", appUrl);
            storeFormData.append("apk_build_type", "Android TV");
            storeFormData.append("client", appFormTV.client);

            storeFormData.append("google_json", appFormTV.google_json ? appFormTV.google_json.name : "");
            storeFormData.append("with_jks", appFormTV.with_jks);

            if (Number(appFormTV.appformat) === 1) {
                storeFormData.append("version_code", appFormTV.version_code);
                storeFormData.append("version_name", appFormTV.version_name);
            }
            storeFormData.append("key_password", appFormTV.key_password);
            storeFormData.append("key_store_password", appFormTV.key_store_password);

            if (appFormTV.with_jks === "1") {
                storeFormData.append("jksfile", appFormTV.jksfile ? appFormTV.jksfile.name : "");
            }

            const storeResponse = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/app-build/store`, storeFormData, { headers });
            if (storeResponse.data.status_code !== 200) {
                throw new Error("Failed to store app data.");
            }

            // Guaranteed list refresh after successful store
            getAppMappings();

            // Isolated Image Upload
            if (appFormTV.app_icon) {
                try {
                    const imageFormData = new FormData();
                    imageFormData.append("id", storeResponse.data.data.id);
                    imageFormData.append("modelName", "AdminAppBuildSetting");
                    imageFormData.append("app_icon", appFormTV.app_icon);
                    imageFormData.append("imageFields[]", "app_icon");
                    const imageResponse = await axios.post(globalImageUplaodAPI(), imageFormData, { headers });
                } catch (imgError) {
                    console.error("TV Image upload error:", imgError);
                }
            }
            toast.success("TV app build process completed and data saved successfully!");

        } catch (error) {
            console.error("Store TV App Build Error:", error);
            const errorMessage = error.response?.data?.message || "Failed to process TV app build.";
            toast.error(errorMessage);
        } finally {
            setShowOverlay(false);
        }
    };

    // Fire
    const handleSubmitFire = async (e) => {
        e.preventDefault();
        const errors = {};
        let valid = true;

        const pkgErrorFire = validatePackageName(appFormFireTV.package_name);
        if (pkgErrorFire) { errors.package_name = pkgErrorFire; valid = false; }

        const validations = [
            { key: "app_name", check: appFormFireTV.app_name?.trim(), message: "App name is required." },
            { key: "app_icon", check: appFormFireTV.app_icon instanceof File, message: "App icon is required." },
            { key: "client", check: appFormFireTV.client?.trim(), message: "Client name is required." },
        ];

        if (Number(appFormFireTV.appformat) === 1) {
            validations.push(
                { key: "version_code", check: appFormFireTV.version_code, message: "Version code is required." },
                { key: "version_name", check: appFormFireTV.version_name?.trim(), message: "Version name is required." },
            );
        }

        validations.push(
            { key: "key_password", check: appFormFireTV.key_password, message: "Key password is required." },
            { key: "key_store_password", check: appFormFireTV.key_store_password, message: "Keystore password is required." }
        );

        if (appFormFireTV.with_jks === "1") {
            validations.push(
                { key: "jksfile", check: appFormFireTV.jksfile instanceof File, message: "JKS file is required." },
            );
        }

        validations.forEach(({ key, check, message }) => {
            if (!check) {
                errors[key] = message;
                valid = false;
            }
        });

        if (!valid) {
            setFormErrorsFireTV(errors);
            return;
        }

        try {
            setShowOverlay(true);
            toast.info("Processing app download...");
            const buildFormData = new FormData();
            buildFormData.append("authToken", authToken);
            buildFormData.append("apptype", "3");
            buildFormData.append("appformat", appFormFireTV.appformat);
            buildFormData.append("app_icon", appFormFireTV.app_icon);
            buildFormData.append("appname", appFormFireTV.app_name);
            buildFormData.append("packagename", appFormFireTV.package_name);
            buildFormData.append("apiurl", appUrl);
            buildFormData.append("buildtype", appFormFireTV.buildtype);
            buildFormData.append("client", appFormFireTV.client);

            buildFormData.append("google_json", appFormFireTV.google_json);
            buildFormData.append("with_jks", appFormFireTV.with_jks);

            if (Number(appFormFireTV.appformat) === 1) {
                buildFormData.append("version_code", appFormFireTV.version_code);
                buildFormData.append("version_name", appFormFireTV.version_name);
            }
            buildFormData.append("key_password", appFormFireTV.key_password);
            buildFormData.append("key_store_password", appFormFireTV.key_store_password);

            if (appFormFireTV.with_jks === "1") {
                buildFormData.append("jksfile", appFormFireTV.jksfile);
            }

            const buildResponse = await axios.post(`${process.env.REACT_APP_Deployment_APP_URL}/admin-flicknexs/build-app`, buildFormData, { headers });
            const downloadUrl = buildResponse?.data?.result;
            if (!downloadUrl) throw new Error("Download URL is missing.");

            const storeFormData = new FormData();
            storeFormData.append("authToken", authToken);
            storeFormData.append("apptype", "3");
            storeFormData.append("buildtype", "1");
            storeFormData.append("appformat", appFormFireTV.appformat);
            storeFormData.append("app_name", appFormFireTV.app_name);
            storeFormData.append("package_name", appFormFireTV.package_name);
            storeFormData.append("build_url", downloadUrl);
            storeFormData.append("api_url", appUrl);
            storeFormData.append("apk_build_type", "Fire Tv");
            storeFormData.append("client", appFormFireTV.client);

            storeFormData.append("google_json", appFormFireTV.google_json ? appFormFireTV.google_json.name : "");
            storeFormData.append("with_jks", appFormFireTV.with_jks);

            if (Number(appFormFireTV.appformat) === 1) {
                storeFormData.append("version_code", appFormFireTV.version_code);
                storeFormData.append("version_name", appFormFireTV.version_name);
            }
            storeFormData.append("key_password", appFormFireTV.key_password);
            storeFormData.append("key_store_password", appFormFireTV.key_store_password);

            if (appFormFireTV.with_jks === "1") {
                storeFormData.append("jksfile", appFormFireTV.jksfile ? appFormFireTV.jksfile.name : "");
            }

            const storeResponse = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/app-build/store`, storeFormData, { headers });
            if (storeResponse.data.status_code !== 200) {
                throw new Error("Failed to store app data.");
            }

            // Guaranteed list refresh after successful store
            getAppMappings();

            // Isolated Image Upload
            if (appFormFireTV.app_icon) {
                try {
                    const imageFormData = new FormData();
                    imageFormData.append("id", storeResponse.data.data.id);
                    imageFormData.append("modelName", "AdminAppBuildSetting");
                    imageFormData.append("app_icon", appFormFireTV.app_icon);
                    imageFormData.append("imageFields[]", "app_icon");
                    const imageResponse = await axios.post(globalImageUplaodAPI(), imageFormData, { headers });
                } catch (imgError) {
                    console.error("Fire TV Image upload error:", imgError);
                }
            }
            toast.success("Fire TV app build process completed and data saved successfully!");

        } catch (error) {
            console.error("Store Fire App Build Error:", error);
            const errorMessage = error.response?.data?.message || "Failed to process Fire app build.";
            toast.error(errorMessage);
        } finally {
            setShowOverlay(false);
        }
    };


    // Samsung
    const handleSubmitSamsung = async (e) => {
        e.preventDefault();
        const errors = {};
        let valid = true;

        const pkgErrorSamsung = validatePackageName(appFormSamsung.package_name);
        if (pkgErrorSamsung) { errors.package_name = pkgErrorSamsung; valid = false; }

        const validations = [
            { key: "app_name", check: appFormSamsung.app_name?.trim(), message: "App name is required." },
            { key: "app_icon", check: appFormSamsung.app_icon instanceof File, message: "App icon is required." },
            { key: "client", check: appFormSamsung.client?.trim(), message: "Client name is required." },
        ];

        if (Number(appFormSamsung.appformat) === 1) {
            validations.push(
                { key: "version_code", check: appFormSamsung.version_code, message: "Version code is required." },
                { key: "version_name", check: appFormSamsung.version_name?.trim(), message: "Version name is required." },
            );
        }

        validations.push(
            { key: "key_password", check: appFormSamsung.key_password, message: "Key password is required." },
            { key: "key_store_password", check: appFormSamsung.key_store_password, message: "Keystore password is required." }
        );

        if (appFormSamsung.with_jks === "1") {
            validations.push(
                { key: "jksfile", check: appFormSamsung.jksfile instanceof File, message: "JKS file is required." },
            );
        }

        validations.forEach(({ key, check, message }) => {
            if (!check) {
                errors[key] = message;
                valid = false;
            }
        });

        if (!valid) {
            setFormErrorsSamsung(errors);
            return;
        }

        try {
            setShowOverlay(true);
            toast.info("Processing app download...");
            const buildFormData = new FormData();
            buildFormData.append("authToken", authToken);
            buildFormData.append("apptype", "4");
            buildFormData.append("appformat", appFormSamsung.appformat);
            buildFormData.append("app_icon", appFormSamsung.app_icon);
            buildFormData.append("appname", appFormSamsung.app_name);
            buildFormData.append("packagename", appFormSamsung.package_name);
            buildFormData.append("apiurl", appUrl);
            buildFormData.append("buildtype", appFormSamsung.buildtype);
            buildFormData.append("client", appFormSamsung.client);

            buildFormData.append("google_json", appFormSamsung.google_json);
            buildFormData.append("with_jks", appFormSamsung.with_jks);

            if (Number(appFormSamsung.appformat) === 1) {
                buildFormData.append("version_code", appFormSamsung.version_code);
                buildFormData.append("version_name", appFormSamsung.version_name);
            }
            buildFormData.append("key_password", appFormSamsung.key_password);
            buildFormData.append("key_store_password", appFormSamsung.key_store_password);

            if (appFormSamsung.with_jks === "1") {
                buildFormData.append("jksfile", appFormSamsung.jksfile);
            }

            const buildResponse = await axios.post(`${process.env.REACT_APP_Deployment_APP_URL}/admin-flicknexs/build-app`, buildFormData, { headers });
            const downloadUrl = buildResponse?.data?.result;
            if (!downloadUrl) throw new Error("Download URL is missing.");

            const storeFormData = new FormData();
            storeFormData.append("authToken", authToken);
            storeFormData.append("apptype", "4");
            storeFormData.append("buildtype", "1");
            storeFormData.append("appformat", appFormSamsung.appformat);
            storeFormData.append("app_name", appFormSamsung.app_name);
            storeFormData.append("package_name", appFormSamsung.package_name);
            storeFormData.append("build_url", downloadUrl);
            storeFormData.append("api_url", appUrl);
            storeFormData.append("apk_build_type", "Samsung TV");
            storeFormData.append("client", appFormSamsung.client);

            storeFormData.append("google_json", appFormSamsung.google_json ? appFormSamsung.google_json.name : "");
            storeFormData.append("with_jks", appFormSamsung.with_jks);

            if (Number(appFormSamsung.appformat) === 1) {
                storeFormData.append("version_code", appFormSamsung.version_code);
                storeFormData.append("version_name", appFormSamsung.version_name);
            }
            storeFormData.append("key_password", appFormSamsung.key_password);
            storeFormData.append("key_store_password", appFormSamsung.key_store_password);

            if (appFormSamsung.with_jks === "1") {
                storeFormData.append("jksfile", appFormSamsung.jksfile ? appFormSamsung.jksfile.name : "");
            }

            const storeResponse = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/app-build/store`, storeFormData, { headers });
            if (storeResponse.data.status_code !== 200) {
                throw new Error("Failed to store app data.");
            }

            // Guaranteed list refresh after successful store
            getAppMappings();

            // Isolated Image Upload
            if (appFormSamsung.app_icon) {
                try {
                    const imageFormData = new FormData();
                    imageFormData.append("id", storeResponse.data.data.id);
                    imageFormData.append("modelName", "AdminAppBuildSetting");
                    imageFormData.append("app_icon", appFormSamsung.app_icon);
                    imageFormData.append("imageFields[]", "app_icon");
                    const imageResponse = await axios.post(globalImageUplaodAPI(), imageFormData, { headers });
                } catch (imgError) {
                    console.error("Samsung  TV Image upload error:", imgError);
                }
            }
            toast.success("Samsung TV app build process completed and data saved successfully!");

        } catch (error) {
            console.error("Store Samsung App Build Error:", error);
            const errorMessage = error.response?.data?.message || "Failed to process Samsung app build.";
            toast.error(errorMessage);
        } finally {
            setShowOverlay(false);
        }
    };
    // lg

    const handleSubmitLG = async (e) => {
        e.preventDefault();
        const errors = {};
        let valid = true;

        const pkgErrorLG = validatePackageName(appFormLGTV.package_name);
        if (pkgErrorLG) { errors.package_name = pkgErrorLG; valid = false; }

        const validations = [
            { key: "app_name", check: appFormLGTV.app_name?.trim(), message: "App name is required." },
            { key: "app_icon", check: appFormLGTV.app_icon instanceof File, message: "App icon is required." },
            { key: "client", check: appFormLGTV.client?.trim(), message: "Client name is required." },
        ];

        if (Number(appFormLGTV.appformat) === 1) {
            validations.push(
                { key: "version_code", check: appFormLGTV.version_code, message: "Version code is required." },
                { key: "version_name", check: appFormLGTV.version_name?.trim(), message: "Version name is required." },
            );
        }

        validations.push(
            { key: "key_password", check: appFormLGTV.key_password, message: "Key password is required." },
            { key: "key_store_password", check: appFormLGTV.key_store_password, message: "Keystore password is required." }
        );

        if (appFormLGTV.with_jks === "1") {
            validations.push(
                { key: "jksfile", check: appFormLGTV.jksfile instanceof File, message: "JKS file is required." },
            );
        }

        validations.forEach(({ key, check, message }) => {
            if (!check) {
                errors[key] = message;
                valid = false;
            }
        });

        if (!valid) {
            setFormErrorsLGTV(errors);
            return;
        }

        try {
            setShowOverlay(true);
            toast.info("Processing app download...");
            const buildFormData = new FormData();
            buildFormData.append("authToken", authToken);
            buildFormData.append("apptype", "5");
            buildFormData.append("appformat", appFormLGTV.appformat);
            buildFormData.append("app_icon", appFormLGTV.app_icon);
            buildFormData.append("appname", appFormLGTV.app_name);
            buildFormData.append("packagename", appFormLGTV.package_name);
            buildFormData.append("apiurl", appUrl);
            buildFormData.append("buildtype", appFormLGTV.buildtype);
            buildFormData.append("client", appFormLGTV.client);

            buildFormData.append("google_json", appFormLGTV.google_json);
            buildFormData.append("with_jks", appFormLGTV.with_jks);

            if (Number(appFormLGTV.appformat) === 1) {
                buildFormData.append("version_code", appFormLGTV.version_code);
                buildFormData.append("version_name", appFormLGTV.version_name);
            }
            buildFormData.append("key_password", appFormLGTV.key_password);
            buildFormData.append("key_store_password", appFormLGTV.key_store_password);

            if (appFormLGTV.with_jks === "1") {
                buildFormData.append("jksfile", appFormLGTV.jksfile);
            }

            const buildResponse = await axios.post(`${process.env.REACT_APP_Deployment_APP_URL}/admin-flicknexs/build-app`, buildFormData, { headers });
            const downloadUrl = buildResponse?.data?.result;
            if (!downloadUrl) throw new Error("Download URL is missing.");

            const storeFormData = new FormData();
            storeFormData.append("authToken", authToken);
            storeFormData.append("apptype", "5");
            storeFormData.append("buildtype", "1");
            storeFormData.append("appformat", appFormLGTV.appformat);
            storeFormData.append("app_name", appFormLGTV.app_name);
            storeFormData.append("package_name", appFormLGTV.package_name);
            storeFormData.append("build_url", downloadUrl);
            storeFormData.append("api_url", appUrl);
            storeFormData.append("apk_build_type", "LG TV");
            storeFormData.append("client", appFormLGTV.client);

            storeFormData.append("google_json", appFormLGTV.google_json ? appFormLGTV.google_json.name : "");
            storeFormData.append("with_jks", appFormLGTV.with_jks);

            if (Number(appFormLGTV.appformat) === 1) {
                storeFormData.append("version_code", appFormLGTV.version_code);
                storeFormData.append("version_name", appFormLGTV.version_name);
            }
            storeFormData.append("key_password", appFormLGTV.key_password);
            storeFormData.append("key_store_password", appFormLGTV.key_store_password);

            if (appFormLGTV.with_jks === "1") {
                storeFormData.append("jksfile", appFormLGTV.jksfile ? appFormLGTV.jksfile.name : "");
            }

            const storeResponse = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/app-build/store`, storeFormData, { headers });
            if (storeResponse.data.status_code !== 200) {
                throw new Error("Failed to store app data.");
            }

            // Guaranteed list refresh after successful store
            getAppMappings();

            // Isolated Image Upload
            if (appFormLGTV.app_icon) {
                try {
                    const imageFormData = new FormData();
                    imageFormData.append("id", storeResponse.data.data.id);
                    imageFormData.append("modelName", "AdminAppBuildSetting");
                    imageFormData.append("app_icon", appFormLGTV.app_icon);
                    imageFormData.append("imageFields[]", "app_icon");
                    const imageResponse = await axios.post(globalImageUplaodAPI(), imageFormData, { headers });
                } catch (imgError) {
                    console.error("LG TV Image upload error:", imgError);
                }
            }
            toast.success("LG TV app build process completed and data saved successfully!");

        } catch (error) {
            console.error("Store LG App Build Error:", error);
            const errorMessage = error.response?.data?.message || "Failed to process LG app build.";
            toast.error(errorMessage);
        } finally {
            setShowOverlay(false);
        }
    };
    const handleSubmitROKO = async (e) => {
        e.preventDefault();
        const errors = {};
        let valid = true;

        const pkgErrorRoku = validatePackageName(appFormRoku.package_name);
        if (pkgErrorRoku) { errors.package_name = pkgErrorRoku; valid = false; }

        const validations = [
            { key: "app_name", check: appFormRoku.app_name?.trim(), message: "App name is required." },
            { key: "app_icon", check: appFormRoku.app_icon instanceof File, message: "App icon is required." },
            { key: "client", check: appFormRoku.client?.trim(), message: "Client name is required." },
        ];

        if (Number(appFormRoku.appformat) === 1) {
            validations.push(
                { key: "version_code", check: appFormRoku.version_code, message: "Version code is required." },
                { key: "version_name", check: appFormRoku.version_name?.trim(), message: "Version name is required." },
            );
        }

        validations.push(
            { key: "key_password", check: appFormRoku.key_password, message: "Key password is required." },
            { key: "key_store_password", check: appFormRoku.key_store_password, message: "Keystore password is required." }
        );

        if (appFormRoku.with_jks === "1") {
            validations.push(
                { key: "jksfile", check: appFormRoku.jksfile instanceof File, message: "JKS file is required." },
            );
        }

        validations.forEach(({ key, check, message }) => {
            if (!check) {
                errors[key] = message;
                valid = false;
            }
        });

        if (!valid) {
            setFormErrorsRoku(errors);
            return;
        }

        try {
            setShowOverlay(true);
            toast.info("Processing app download...");
            const buildFormData = new FormData();
            buildFormData.append("authToken", authToken);
            buildFormData.append("apptype", "6");
            buildFormData.append("appformat", appFormRoku.appformat);
            buildFormData.append("app_icon", appFormRoku.app_icon);
            buildFormData.append("appname", appFormRoku.app_name);
            buildFormData.append("packagename", appFormRoku.package_name);
            buildFormData.append("apiurl", appUrl);
            buildFormData.append("buildtype", appFormRoku.buildtype);
            buildFormData.append("client", appFormRoku.client);

            buildFormData.append("google_json", appFormRoku.google_json);
            buildFormData.append("with_jks", appFormRoku.with_jks);

            if (Number(appFormRoku.appformat) === 1) {
                buildFormData.append("version_code", appFormRoku.version_code);
                buildFormData.append("version_name", appFormRoku.version_name);
            }
            buildFormData.append("key_password", appFormRoku.key_password);
            buildFormData.append("key_store_password", appFormRoku.key_store_password);

            if (appFormRoku.with_jks === "1") {
                buildFormData.append("jksfile", appFormRoku.jksfile);
            }

            const buildResponse = await axios.post(`${process.env.REACT_APP_Deployment_APP_URL}/admin-flicknexs/build-app`, buildFormData, { headers });
            const downloadUrl = buildResponse?.data?.result;
            if (!downloadUrl) throw new Error("Download URL is missing.");

            const storeFormData = new FormData();
            storeFormData.append("authToken", authToken);
            storeFormData.append("apptype", "6");
            storeFormData.append("buildtype", "1");
            storeFormData.append("appformat", appFormRoku.appformat);
            storeFormData.append("app_name", appFormRoku.app_name);
            storeFormData.append("package_name", appFormRoku.package_name);
            storeFormData.append("build_url", downloadUrl);
            storeFormData.append("api_url", appUrl);
            storeFormData.append("apk_build_type", "ROKO");
            storeFormData.append("client", appFormRoku.client);

            storeFormData.append("google_json", appFormRoku.google_json ? appFormRoku.google_json.name : "");
            storeFormData.append("with_jks", appFormRoku.with_jks);

            if (Number(appFormRoku.appformat) === 1) {
                storeFormData.append("version_code", appFormRoku.version_code);
                storeFormData.append("version_name", appFormRoku.version_name);
            }
            storeFormData.append("key_password", appFormRoku.key_password);
            storeFormData.append("key_store_password", appFormRoku.key_store_password);

            if (appFormRoku.with_jks === "1") {
                storeFormData.append("jksfile", appFormRoku.jksfile ? appFormRoku.jksfile.name : "");
            }

            const storeResponse = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/app-build/store`, storeFormData, { headers });
            if (storeResponse.data.status_code !== 200) {
                throw new Error("Failed to store app data.");
            }

            // Guaranteed list refresh after successful store
            getAppMappings();

            // Isolated Image Upload
            if (appFormRoku.app_icon) {
                try {
                    const imageFormData = new FormData();
                    imageFormData.append("id", storeResponse.data.data.id);
                    imageFormData.append("modelName", "AdminAppBuildSetting");
                    imageFormData.append("app_icon", appFormRoku.app_icon);
                    imageFormData.append("imageFields[]", "app_icon");
                    const imageResponse = await axios.post(globalImageUplaodAPI(), imageFormData, { headers });
                } catch (imgError) {
                    console.error("Roku Image upload error:", imgError);
                }
            }
            toast.success("Roku app build process completed and data saved successfully!");

        } catch (error) {
            console.error("Store Roku App Build Error:", error);
            const errorMessage = error.response?.data?.message || "Failed to process Roku app build.";
            toast.error(errorMessage);
        } finally {
            setShowOverlay(false);
        }
    };

    const handleInput = async (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
        setFormDataError((prevFormData) => ({
            ...prevFormData,
            [name]: "",
        }));
    }

    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.API_URL) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                API_URL: "API URL cannot be empty.",
            }));
            formIsValid = false;
        }
        if (!formData?.authToken) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                authToken: "Auth token cannot be empty.",
            }));
            formIsValid = false;
        }
        return formIsValid;
    }


    const handleSubmitAppSetting = async (e) => {
        e.preventDefault();
        if (formValidation()) {
            await handleAdd();
        } else {
            console.log("Form validation failed");
            toast.error("Please fill all required fields.");
        }
    };

    const handleAdd = async () => {
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (['API_URL', 'authToken'].includes(key)) {
                    formDataAdd[key] = formData[key];
                }
            }

            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/app-build/auth-update`, formDataAdd, { headers: headers });
            const result = response?.data;
            if (result?.status) {
                setShowOverlay(false);
                setFormData({
                    API_URL: result?.data?.API_URL || "",
                    authToken: result?.data?.authToken || ""
                });
                toast.success(result?.message)
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            console.error("error----", errorMessage)
            toast.error(errorMessage)
        }
    }

    return (
        <>
            {showOverlay && (<Response_Processing></Response_Processing>)}
            <div className="apps-container">
                <h4 className="admin-title theme-text-color text-md-start mb-3">Apps</h4>

                <Wrapper>
                    <MessageHeading text={"API Configuration"} />
                    <div className="d-flex row">
                        <div className="col-md-6">
                            <div className="mt-2 mb-2">
                                <MessageLabel text="API URL" />
                                <AdminCustomInput type="text" name="API_URL" value={appUrl} isReadonly />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mt-2 mb-2">
                                <MessageLabel text="Auth Token" />
                                <div className="position-relative">
                                    <input type={passwordType} name="authToken" value={appPassword} readOnly className="rs-input py-3 px-5 form-control-lg custom-placeholder custom-input-border theme-text-color mb-3 custom-input" />
                                    <button
                                        onClick={togglePassword}
                                        type="button"
                                        className="position-absolute passWordIcon bg-transparent"
                                    >
                                        {passwordType === "password" ? (
                                            <TbEyeClosed className="eyeClosed text-dark" />
                                        ) : (
                                            <VscEye className="eyeOpen text-dark" />
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wrapper >

                <ul className="nav nav-pills appstv my-3" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="pills-App-tab" data-bs-toggle="pill" data-bs-target="#pills-App" type="button" role="tab" aria-controls="pills-App" aria-selected="true">Android App</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-TV-tab" data-bs-toggle="pill" data-bs-target="#pills-TV" type="button" role="tab" aria-controls="pills-TV" aria-selected="false">Android TV</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-Fire-tab" data-bs-toggle="pill" data-bs-target="#pills-Fire" type="button" role="tab" aria-controls="pills-Fire" aria-selected="false">Fire TV</button>
                    </li>
                    {/* <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-Samsung-tab" data-bs-toggle="pill" data-bs-target="#pills-Samsung" type="button" role="tab" aria-controls="pills-Samsung" aria-selected="true">Samsung TV</button>
                    </li> */}
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-LG-tab" data-bs-toggle="pill" data-bs-target="#pills-LG" type="button" role="tab" aria-controls="pills-LG" aria-selected="false">LG TV</button>
                    </li>
                    {/* <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-ROKO-tab" data-bs-toggle="pill" data-bs-target="#pills-ROKO" type="button" role="tab" aria-controls="pills-ROKO" aria-selected="false">ROKO</button>
                    </li> */}
                    {/* <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-IOS-tab" data-bs-toggle="pill" data-bs-target="#pills-IOS" type="button" role="tab" aria-controls="pills-IOS" aria-selected="false">IOS</button>
                    </li> */}

                </ul>
                <div className="tab-content mt-2" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="pills-App" role="tabpanel" aria-labelledby="pills-App-tab" tabindex="0">
                        {/* <form onSubmit={handleSubmitApp}> */}

                        <div className="d-flex gap-3 mt-3">
                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="0"
                                    checked={appFormApp.appformat === "0"}
                                    onChange={handleInputApp}
                                /> APK
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="1"
                                    checked={appFormApp.appformat === "1"}
                                    onChange={handleInputApp}
                                /> AAB
                            </label>
                        </div>


                        <FormContainer>
                            <LeftWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Details"} />
                                    <MessageLabel text="App Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" id="app-app_name" name="app_name" placeHolder={"Enter App Name"} value={appFormApp.app_name} onChange={handleInputApp} error={formErrorsApp.app_name} />
                                    <div className="d-flex align-items-center gap-1 mb-1">
                                        <MessageLabel text="Package Name" className="mandatorySimple" />
                                        <div className="position-relative d-inline-flex" style={{ cursor: "pointer" }}>
                                            <IoMdInformationCircle className="theme-text-color" style={{ width: "16px", height: "16px" }} />
                                            <span className="pkg-info-tooltip">Please add package name</span>
                                        </div>
                                    </div>
                                    <AdminCustomInput type="text" id="app-package_name" name="package_name" placeHolder={"com.organisation.appname"} value={appFormApp.package_name} onChange={handleInputApp} error={formErrorsApp.package_name} />
                                    <MessageLabel text="Client Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" name="client" value={appFormApp.client} onChange={handleInputApp} error={formErrorsApp.client} />

                                    <MessageLabel text="Google JSON" />
                                    <input
                                        className={`rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3 mt-2 ${formErrorsApp.google_json && 'custom-input-error'}`}
                                        type="file"
                                        name="google_json"
                                        accept=".json"
                                        onChange={handleInputApp}
                                    />
                                    {formErrorsApp.google_json && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsApp.google_json}`} classname='errorred d-block' /></div>)}

                                    {appFormApp.appformat == 1 && (
                                        <>
                                            <MessageLabel text="Version Code" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_code"
                                                placeHolder="Enter numbers only"
                                                value={appFormApp.version_code}
                                                onChange={handleInputApp}
                                                error={formErrorsApp.version_code}
                                            />

                                            <MessageLabel text="Version Name" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_name"
                                                placeHolder="Enter version (e.g. 1.0.0)"
                                                value={appFormApp.version_name}
                                                onChange={handleInputApp}
                                                error={formErrorsApp.version_name}
                                            />
                                        </>
                                    )}
                                </Wrapper>
                            </LeftWrapper>
                            <RightWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Icon"} className="mandatorySimple" />
                                    <div className="mt-2">
                                        <p className="theme-text-color  mt-0 admin-input-title d-block position-relative">App Icon</p>
                                        <span className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Only PNG, JPG, JPEG formats are allowed. Image must be exactly 512 x 512 pixels.</span>
                                        <input
                                            className={`rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3 mt-2  ${formErrorsApp.app_icon && 'custom-input-error'} `}
                                            type="file"
                                            name="app_icon"
                                            required
                                            accept=".png, .jpg, .jpeg"
                                            onChange={handleInputApp}
                                        />
                                        {formErrorsApp.app_icon && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsApp.app_icon}`} classname='errorred  d-block' /></div>)}
                                    </div>
                                </Wrapper>

                                    <Wrapper>
                                        <MessageHeading text="Signing Config" />
                                        <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                                            <p className="theme-text-color admin-input-title mb-0">With JKS</p>
                                            <AdminSwitch
                                                name="with_jks"
                                                checked={appFormApp.with_jks === "1"}
                                                onChange={handleInputApp}
                                            />
                                        </div>

                                        {appFormApp.with_jks === "1" && (
                                            <>
                                                <MessageLabel text="JKS File" className="mandatorySimple" />
                                                <input type="file" name="jksfile" accept=".jks" id="app_jks_file" className={`form-control mb-3 ${formErrorsApp.jksfile && "custom-input-error"}`} onChange={handleInputApp} />
                                            </>
                                        )}
                                        <MessageLabel text="Key Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_password" id="app_key_password" placeHolder="Key Password" value={appFormApp.key_password} onChange={handleInputApp} error={formErrorsApp.key_password} />
                                        <MessageLabel text="Keystore Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_store_password" id="app_key_store_password" placeHolder="Keystore Password" value={appFormApp.key_store_password} onChange={handleInputApp} error={formErrorsApp.key_store_password} />
                                    </Wrapper>
                            </RightWrapper>
                            <AdminCustomButton saveMethod={handleSubmitApp} saveText={"Submit"} className="ms-auto d-flex justify-content-center" />
                        </FormContainer>
                        {/* </form> */}
                    </div>
                    <div className="tab-pane fade" id="pills-TV" role="tabpanel" aria-labelledby="pills-TV-tab" tabindex="0">
                        {/* <form onSubmit={handleSubmitTV}> */}

                        <div className="d-flex gap-3 mt-3">
                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="0"
                                    checked={appFormTV.appformat === "0"}
                                    onChange={handleInputTV}
                                /> APK
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="1"
                                    checked={appFormTV.appformat === "1"}
                                    onChange={handleInputTV}
                                /> AAB
                            </label>
                        </div>

                        <FormContainer>
                            <LeftWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Details"} />
                                    <MessageLabel text="App Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" id="tv_app_name" name="app_name" placeHolder={"Enter App Name"} value={appFormTV.app_name} onChange={handleInputTV} error={formErrorsTV.app_name} />
                                    <div className="d-flex align-items-center gap-1 mb-1">
                                        <MessageLabel text="Package Name" className="mandatorySimple" />
                                        <div className="position-relative d-inline-flex" style={{ cursor: "pointer" }}>
                                            <IoMdInformationCircle className="theme-text-color" style={{ width: "16px", height: "16px" }} />
                                            <span className="pkg-info-tooltip">Please add package name</span>
                                        </div>
                                    </div>
                                    <AdminCustomInput type="text" id="tv_package_name" name="package_name" placeHolder={"com.organisation.appname"} value={appFormTV.package_name} onChange={handleInputTV} error={formErrorsTV.package_name} />
                                    <MessageLabel text="Client Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" name="client" value={appFormTV.client} onChange={handleInputTV} error={formErrorsTV.client} />

                                    <MessageLabel text="Google JSON" />
                                    <input
                                        className={`rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3 mt-2 ${formErrorsTV.google_json && 'custom-input-error'}`}
                                        type="file"
                                        name="google_json"
                                        accept=".json"
                                        onChange={handleInputTV}
                                    />
                                    {formErrorsTV.google_json && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsTV.google_json}`} classname='errorred d-block' /></div>)}

                                    {appFormTV.appformat == 1 && (
                                        <>
                                            <MessageLabel text="Version Code" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_code"
                                                placeHolder="Enter numbers only"
                                                value={appFormTV.version_code}
                                                onChange={handleInputTV}
                                                error={formErrorsTV.version_code}
                                            />

                                            <MessageLabel text="Version Name" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_name"
                                                placeHolder="Enter version (e.g. 1.0.0)"
                                                value={appFormTV.version_name}
                                                onChange={handleInputTV}
                                                error={formErrorsTV.version_name}
                                            />
                                        </>
                                    )}
                                </Wrapper>
                            </LeftWrapper>
                            <RightWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Icon"} className="mandatorySimple" />
                                    <div className="mt-2">
                                        <p className="theme-text-color mt-0 admin-input-title d-block position-relative">App Icon</p>
                                        <span className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Only PNG, JPG, JPEG formats are allowed. Image must be exactly 512 x 512 pixels.</span>
                                        <input
                                            className={`rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3 mt-2  ${formErrorsTV.app_icon && 'custom-input-error'} `}
                                            type="file"
                                            name="app_icon"
                                            required
                                            accept=".png, .jpg, .jpeg"
                                            onChange={handleInputTV}
                                        />
                                        {formErrorsTV.app_icon && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsTV.app_icon}`} classname='errorred  d-block' /></div>)}
                                    </div>
                                </Wrapper>

                                    <Wrapper>
                                        <MessageHeading text="Signing Config" />
                                        <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                                            <p className="theme-text-color admin-input-title mb-0">With JKS</p>
                                            <AdminSwitch
                                                name="with_jks"
                                                checked={appFormTV.with_jks === "1"}
                                                onChange={handleInputTV}
                                            />
                                        </div>

                                        {appFormTV.with_jks === "1" && (
                                            <>
                                                <MessageLabel text="JKS File" className="mandatorySimple" />
                                                <input type="file" name="jksfile" accept=".jks" id="tv_jks_file" className={`form-control mb-3 ${formErrorsTV.jksfile && "custom-input-error"}`} onChange={handleInputTV} />
                                            </>
                                        )}
                                        <MessageLabel text="Key Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_password" id="tv_key_password" placeHolder="Key Password" value={appFormTV.key_password} onChange={handleInputTV} error={formErrorsTV.key_password} />
                                        <MessageLabel text="Keystore Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_store_password" id="tv_key_store_password" placeHolder="Keystore Password" value={appFormTV.key_store_password} onChange={handleInputTV} error={formErrorsTV.key_store_password} />
                                    </Wrapper>
                            </RightWrapper>
                            <AdminCustomButton saveMethod={handleSubmitTV} saveText={"Submit"} className="ms-auto d-flex justify-content-center" />
                        </FormContainer>
                        {/* </form> */}
                    </div>
                    <div className="tab-pane fade" id="pills-Fire" role="tabpanel" aria-labelledby="pills-Fire-tab" tabindex="0">
                        {/* <form onSubmit={handleSubmitFire}> */}

                        <div className="d-flex gap-3 mt-3">
                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="0"
                                    checked={appFormFireTV.appformat === "0"}
                                    onChange={handleInputFireTV}
                                /> APK
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="1"
                                    checked={appFormFireTV.appformat === "1"}
                                    onChange={handleInputFireTV}
                                /> AAB
                            </label>
                        </div>

                        <FormContainer>
                            <LeftWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Details"} />
                                    <MessageLabel text="App Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" id="fire_app_name" name="app_name" placeHolder={"Enter App Name"} value={appFormFireTV.app_name} onChange={handleInputFireTV} error={formErrorsFireTV.app_name} />
                                    <div className="d-flex align-items-center gap-1 mb-1">
                                        <MessageLabel text="Package Name" className="mandatorySimple" />
                                        <div className="position-relative d-inline-flex" style={{ cursor: "pointer" }}>
                                            <IoMdInformationCircle className="theme-text-color" style={{ width: "16px", height: "16px" }} />
                                            <span className="pkg-info-tooltip">Please add package name</span>
                                        </div>
                                    </div>
                                    <AdminCustomInput type="text" id="fire_package_name" name="package_name" placeHolder={"com.organisation.appname"} value={appFormFireTV.package_name} onChange={handleInputFireTV} error={formErrorsFireTV.package_name} />
                                    <MessageLabel text="Client Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" name="client" value={appFormFireTV.client} onChange={handleInputFireTV} error={formErrorsFireTV.client} />

                                    <MessageLabel text="Google JSON" />
                                    <input
                                        className={`rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3 mt-2 ${formErrorsFireTV.google_json && 'custom-input-error'}`}
                                        type="file"
                                        name="google_json"
                                        accept=".json"
                                        onChange={handleInputFireTV}
                                    />
                                    {formErrorsFireTV.google_json && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsFireTV.google_json}`} classname='errorred d-block' /></div>)}

                                    {appFormFireTV.appformat == 1 && (
                                        <>
                                            <MessageLabel text="Version Code" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_code"
                                                placeHolder="Enter numbers only"
                                                value={appFormFireTV.version_code}
                                                onChange={handleInputFireTV}
                                                error={formErrorsFireTV.version_code}
                                            />

                                            <MessageLabel text="Version Name" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_name"
                                                placeHolder="Enter version (e.g. 1.0.0)"
                                                value={appFormFireTV.version_name}
                                                onChange={handleInputFireTV}
                                                error={formErrorsFireTV.version_name}
                                            />
                                        </>
                                    )}
                                </Wrapper>
                            </LeftWrapper>
                            <RightWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Icon"} className="mandatorySimple" />
                                    <div className="mt-2">
                                        <p className="theme-text-color mt-0 admin-input-title d-block position-relative">App Icon</p>
                                        <span className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Only PNG, JPG, JPEG formats are allowed. Image must be exactly 512 x 512 pixels.</span>
                                        <input
                                            className={`rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3 mt-2  ${formErrorsFireTV.app_icon && 'custom-input-error'} `}
                                            type="file"
                                            name="app_icon"
                                            required
                                            accept=".png, .jpg, .jpeg"
                                            onChange={handleInputFireTV}
                                        />
                                        {formErrorsFireTV.app_icon && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsFireTV.app_icon}`} classname='errorred  d-block' /></div>)}

                                    </div>
                                </Wrapper>

                                    <Wrapper>
                                        <MessageHeading text="Signing Config" />
                                        <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                                            <p className="theme-text-color admin-input-title mb-0">With JKS</p>
                                            <AdminSwitch
                                                name="with_jks"
                                                checked={appFormFireTV.with_jks === "1"}
                                                onChange={handleInputFireTV}
                                            />
                                        </div>

                                        {appFormFireTV.with_jks === "1" && (
                                            <>
                                                <MessageLabel text="JKS File" className="mandatorySimple" />
                                                <input type="file" name="jksfile" accept=".jks" id="fire_jks_file" className={`form-control mb-3 ${formErrorsFireTV.jksfile && "custom-input-error"}`} onChange={handleInputFireTV} />
                                            </>
                                        )}
                                        <MessageLabel text="Key Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_password" id="fire_key_password" placeHolder="Key Password" value={appFormFireTV.key_password} onChange={handleInputFireTV} error={formErrorsFireTV.key_password} />
                                        <MessageLabel text="Keystore Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_store_password" id="fire_key_store_password" placeHolder="Keystore Password" value={appFormFireTV.key_store_password} onChange={handleInputFireTV} error={formErrorsFireTV.key_store_password} />
                                    </Wrapper>
                            </RightWrapper>
                            <AdminCustomButton saveMethod={handleSubmitFire} saveText={"Submit"} className="ms-auto d-flex justify-content-center" />
                        </FormContainer>
                        {/* </form> */}
                    </div>
                    <div className="tab-pane fade" id="pills-Samsung" role="tabpanel" aria-labelledby="pills-Samsung-tab" tabindex="0">
                        {/* <form onSubmit={handleSubmitSamsung}> */}

                        <div className="d-flex gap-3 mt-3">
                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="0"
                                    checked={appFormSamsung.appformat === "0"}
                                    onChange={handleInputSamsung}
                                /> APK
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="1"
                                    checked={appFormSamsung.appformat === "1"}
                                    onChange={handleInputSamsung}
                                /> AAB
                            </label>
                        </div>

                        <FormContainer>
                            <LeftWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Details"} />
                                    <MessageLabel text="App Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" id="samsung_app_name" name="app_name" placeHolder={"Enter App Name"} value={appFormSamsung.app_name} onChange={handleInputSamsung} error={formErrorsSamsung.app_name} />
                                    <div className="d-flex align-items-center gap-1 mb-1">
                                        <MessageLabel text="Package Name" className="mandatorySimple" />
                                        <div className="position-relative d-inline-flex" style={{ cursor: "pointer" }}>
                                            <IoMdInformationCircle className="theme-text-color" style={{ width: "16px", height: "16px" }} />
                                            <span className="pkg-info-tooltip">Please add package name</span>
                                        </div>
                                    </div>
                                    <AdminCustomInput type="text" id="samsung_package_name" name="package_name" placeHolder={"com.organisation.appname"} value={appFormSamsung.package_name} onChange={handleInputSamsung} error={formErrorsSamsung.package_name} />
                                    <MessageLabel text="Client Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" name="client" value={appFormSamsung.client} onChange={handleInputSamsung} error={formErrorsSamsung.client} />

                                    <MessageLabel text="Google JSON" />
                                    <input
                                        className={`rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3 mt-2 ${formErrorsSamsung.google_json && 'custom-input-error'}`}
                                        type="file"
                                        name="google_json"
                                        accept=".json"
                                        onChange={handleInputSamsung}
                                    />
                                    {formErrorsSamsung.google_json && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsSamsung.google_json}`} classname='errorred d-block' /></div>)}

                                    {appFormSamsung.appformat == 1 && (
                                        <>
                                            <MessageLabel text="Version Code" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_code"
                                                placeHolder="Enter numbers only"
                                                value={appFormSamsung.version_code}
                                                onChange={handleInputSamsung}
                                                error={formErrorsSamsung.version_code}
                                            />

                                            <MessageLabel text="Version Name" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_name"
                                                placeHolder="Enter version (e.g. 1.0.0)"
                                                value={appFormSamsung.version_name}
                                                onChange={handleInputSamsung}
                                                error={formErrorsSamsung.version_name}
                                            />
                                        </>
                                    )}
                                </Wrapper>
                            </LeftWrapper>
                            <RightWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Icon"} className="mandatorySimple" />
                                    <div className="mt-2">
                                        <p className="theme-text-color mt-0 admin-input-title d-block position-relative">App Icon</p>
                                        <span className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Only PNG, JPG, JPEG formats are allowed. Image must be exactly 512 x 512 pixels.</span>
                                        <input
                                            className={`rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3 mt-2  ${formErrorsSamsung.app_icon && 'custom-input-error'} `}
                                            type="file"
                                            name="app_icon"
                                            required
                                            accept=".png, .jpg, .jpeg"
                                            onChange={handleInputSamsung}
                                        />
                                        {formErrorsSamsung.app_icon && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsSamsung.app_icon}`} classname='errorred  d-block' /></div>)}
                                    </div>
                                </Wrapper>

                                    <Wrapper>
                                        <MessageHeading text="Signing Config" />
                                        <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                                            <p className="theme-text-color admin-input-title mb-0">With JKS</p>
                                            <AdminSwitch
                                                name="with_jks"
                                                checked={appFormSamsung.with_jks === "1"}
                                                onChange={handleInputSamsung}
                                            />
                                        </div>

                                        {appFormSamsung.with_jks === "1" && (
                                            <>
                                                <MessageLabel text="JKS File" className="mandatorySimple" />
                                                <input type="file" name="jksfile" accept=".jks" id="samsung_jks_file" className={`form-control mb-3 ${formErrorsSamsung.jksfile && "custom-input-error"}`} onChange={handleInputSamsung} />
                                            </>
                                        )}
                                        <MessageLabel text="Key Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_password" id="samsung_key_password" placeHolder="Key Password" value={appFormSamsung.key_password} onChange={handleInputSamsung} error={formErrorsSamsung.key_password} />
                                        <MessageLabel text="Keystore Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_store_password" id="samsung_key_store_password" placeHolder="Keystore Password" value={appFormSamsung.key_store_password} onChange={handleInputSamsung} error={formErrorsSamsung.key_store_password} />
                                    </Wrapper>
                            </RightWrapper>
                            <AdminCustomButton saveMethod={handleSubmitSamsung} saveText={"Submit"} className="ms-auto d-flex justify-content-center" />
                        </FormContainer>
                        {/* </form> */}
                    </div>
                    <div className="tab-pane fade" id="pills-LG" role="tabpanel" aria-labelledby="pills-LG" tabindex="0">
                        {/* <form onSubmit={handleSubmitLG}> */}

                        <div className="d-flex gap-3 mt-3">
                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="0"
                                    checked={appFormLGTV.appformat === "0"}
                                    onChange={handleInputLGTV}
                                /> APK
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="1"
                                    checked={appFormLGTV.appformat === "1"}
                                    onChange={handleInputLGTV}
                                /> AAB
                            </label>
                        </div>

                        <FormContainer>
                            <LeftWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Details"} />
                                    <MessageLabel text="App Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" id="lg_app_name" name="app_name" placeHolder={"Enter App Name"} value={appFormLGTV.app_name} onChange={handleInputLGTV} error={formErrorsLGTV.app_name} />
                                    <div className="d-flex align-items-center gap-1 mb-1">
                                        <MessageLabel text="Package Name" className="mandatorySimple" />
                                        <div className="position-relative d-inline-flex" style={{ cursor: "pointer" }}>
                                            <IoMdInformationCircle className="theme-text-color" style={{ width: "16px", height: "16px" }} />
                                            <span className="pkg-info-tooltip">Please add package name</span>
                                        </div>
                                    </div>
                                    <AdminCustomInput type="text" id="lg_package_name" name="package_name" placeHolder={"com.organisation.appname"} value={appFormLGTV.package_name} onChange={handleInputLGTV} error={formErrorsLGTV.package_name} />
                                    <MessageLabel text="Client Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" name="client" value={appFormLGTV.client} onChange={handleInputLGTV} error={formErrorsLGTV.client} />

                                    <MessageLabel text="Google JSON" />
                                    <input
                                        className={`rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3 mt-2 ${formErrorsLGTV.google_json && 'custom-input-error'}`}
                                        type="file"
                                        name="google_json"
                                        accept=".json"
                                        onChange={handleInputLGTV}
                                    />
                                    {formErrorsLGTV.google_json && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsLGTV.google_json}`} classname='errorred d-block' /></div>)}

                                    {appFormLGTV.appformat == 1 && (
                                        <>
                                            <MessageLabel text="Version Code" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_code"
                                                placeHolder="Enter numbers only"
                                                value={appFormLGTV.version_code}
                                                onChange={handleInputLGTV}
                                                error={formErrorsLGTV.version_code}
                                            />

                                            <MessageLabel text="Version Name" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_name"
                                                placeHolder="Enter version (e.g. 1.0.0)"
                                                value={appFormLGTV.version_name}
                                                onChange={handleInputLGTV}
                                                error={formErrorsLGTV.version_name}
                                            />
                                        </>
                                    )}
                                </Wrapper>
                            </LeftWrapper>
                            <RightWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Icon"} className="mandatorySimple" />
                                    <div className="mt-2">
                                        <p className="theme-text-color mt-0 admin-input-title d-block position-relative">App Icon</p>
                                        <span className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Only PNG, JPG, JPEG formats are allowed. Image must be exactly 512 x 512 pixels.</span>
                                        <input
                                            className={`rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3 mt-2  ${formErrorsLGTV.app_icon && 'custom-input-error'} `}
                                            type="file"
                                            name="app_icon"
                                            required
                                            accept=".png, .jpg, .jpeg"
                                            onChange={handleInputLGTV}
                                        />
                                        {formErrorsLGTV.app_icon && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsLGTV.app_icon}`} classname='errorred  d-block' /></div>)}

                                    </div>
                                </Wrapper>

                                    <Wrapper>
                                        <MessageHeading text="Signing Config" />
                                        <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                                            <p className="theme-text-color admin-input-title mb-0">With JKS</p>
                                            <AdminSwitch
                                                name="with_jks"
                                                checked={appFormLGTV.with_jks === "1"}
                                                onChange={handleInputLGTV}
                                            />
                                        </div>

                                        {appFormLGTV.with_jks === "1" && (
                                            <>
                                                <MessageLabel text="JKS File" className="mandatorySimple" />
                                                <input type="file" name="jksfile" accept=".jks" id="lg_jks_file" className={`form-control mb-3 ${formErrorsLGTV.jksfile && "custom-input-error"}`} onChange={handleInputLGTV} />
                                            </>
                                        )}
                                        <MessageLabel text="Key Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_password" id="lg_key_password" placeHolder="Key Password" value={appFormLGTV.key_password} onChange={handleInputLGTV} error={formErrorsLGTV.key_password} />
                                        <MessageLabel text="Keystore Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_store_password" id="lg_key_store_password" placeHolder="Keystore Password" value={appFormLGTV.key_store_password} onChange={handleInputLGTV} error={formErrorsLGTV.key_store_password} />
                                    </Wrapper>
                            </RightWrapper>

                            <AdminCustomButton saveMethod={handleSubmitLG} saveText={"Submit"} className="ms-auto d-flex justify-content-center" />
                        </FormContainer>
                        {/* </form> */}
                    </div>
                    <div className="tab-pane fade" id="pills-ROKO" role="tabpanel" aria-labelledby="pills-ROKO-tab" tabindex="0">
                        {/* <form onSubmit={handleSubmitROKO}> */}

                        <div className="d-flex gap-3 mt-3">
                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="0"
                                    checked={appFormRoku.appformat === "0"}
                                    onChange={handleInputRoku}
                                /> APK
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name="appformat"
                                    value="1"
                                    checked={appFormRoku.appformat === "1"}
                                    onChange={handleInputRoku}
                                /> AAB
                            </label>
                        </div>

                        <FormContainer>
                            <LeftWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Details"} />
                                    <MessageLabel text="App Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" id="roku_app_name" name="app_name" placeHolder={"Enter App Name"} value={appFormRoku.app_name} onChange={handleInputRoku} error={formErrorsRoku.app_name} />
                                    <div className="d-flex align-items-center gap-1 mb-1">
                                        <MessageLabel text="Package Name" className="mandatorySimple" />
                                        <div className="position-relative d-inline-flex" style={{ cursor: "pointer" }}>
                                            <IoMdInformationCircle className="theme-text-color" style={{ width: "16px", height: "16px" }} />
                                            <span className="pkg-info-tooltip">Please add package name</span>
                                        </div>
                                    </div>
                                    <AdminCustomInput type="text" id="roku_package_name" name="package_name" placeHolder={"com.organisation.appname"} value={appFormRoku.package_name} onChange={handleInputRoku} error={formErrorsRoku.package_name} />
                                    <MessageLabel text="Client Name" className="mandatorySimple" />
                                    <AdminCustomInput type="text" name="client" value={appFormRoku.client} onChange={handleInputRoku} error={formErrorsRoku.client} />

                                    <MessageLabel text="Google JSON" />
                                    <input
                                        className={`rs-input form-control-lg custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3 mt-2 ${formErrorsRoku.google_json && 'custom-input-error'}`}
                                        type="file"
                                        name="google_json"
                                        accept=".json"
                                        onChange={handleInputRoku}
                                    />
                                    {formErrorsRoku.google_json && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsRoku.google_json}`} classname='errorred d-block' /></div>)}

                                    {appFormRoku.appformat == 1 && (
                                        <>
                                            <MessageLabel text="Version Code" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_code"
                                                placeHolder="Enter numbers only"
                                                value={appFormRoku.version_code}
                                                onChange={handleInputRoku}
                                                error={formErrorsRoku.version_code}
                                            />

                                            <MessageLabel text="Version Name" className="mandatorySimple" />
                                            <AdminCustomInput
                                                type="text"
                                                name="version_name"
                                                placeHolder="Enter version (e.g. 1.0.0)"
                                                value={appFormRoku.version_name}
                                                onChange={handleInputRoku}
                                                error={formErrorsRoku.version_name}
                                            />
                                        </>
                                    )}
                                </Wrapper>
                            </LeftWrapper>
                            <RightWrapper>
                                <Wrapper>
                                    <MessageHeading text={"App Icon"} className="mandatorySimple" />
                                    <div className="mt-2">
                                        <p className="theme-text-color mt-0 admin-input-title d-block position-relative">App Icon</p>
                                        <span className="mb-3 mt-0 theme-text-color opacity-75 admin-input-description">Only PNG, JPG, JPEG formats are allowed. Image must be exactly 512 x 512 pixels.</span>
                                        <input
                                            className={`rs-input form-control-lg custom-input  custom-input-border w-100 custom-placeholder bg-transparent  theme-text-color mb-3 mt-2  ${formErrorsRoku.app_icon && 'custom-input-error'} `}
                                            type="file"
                                            name="app_icon"
                                            required
                                            accept=".png, .jpg, .jpeg"
                                            onChange={handleInputRoku}
                                        />
                                        {formErrorsRoku.app_icon && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formErrorsRoku.app_icon}`} classname='errorred  d-block' /></div>)}
                                    </div>
                                </Wrapper>

                                    <Wrapper>
                                        <MessageHeading text="Signing Config" />
                                        <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                                            <p className="theme-text-color admin-input-title mb-0">With JKS</p>
                                            <AdminSwitch
                                                name="with_jks"
                                                checked={appFormRoku.with_jks === "1"}
                                                onChange={handleInputRoku}
                                            />
                                        </div>

                                        {appFormRoku.with_jks === "1" && (
                                            <>
                                                <MessageLabel text="JKS File" className="mandatorySimple" />
                                                <input type="file" name="jksfile" accept=".jks" id="roku_jks_file" className={`form-control mb-3 ${formErrorsRoku.jksfile && "custom-input-error"}`} onChange={handleInputRoku} />
                                            </>
                                        )}
                                        <MessageLabel text="Key Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_password" id="roku_key_password" placeHolder="Key Password" value={appFormRoku.key_password} onChange={handleInputRoku} error={formErrorsRoku.key_password} />
                                        <MessageLabel text="Keystore Password" className="mandatorySimple" />
                                        <AdminCustomInput autoComplete="new-password" type="password" name="key_store_password" id="roku_key_store_password" placeHolder="Keystore Password" value={appFormRoku.key_store_password} onChange={handleInputRoku} error={formErrorsRoku.key_store_password} />
                                    </Wrapper>
                            </RightWrapper>
                            <AdminCustomButton saveMethod={handleSubmitROKO} saveText={"Submit"} className="ms-auto d-flex justify-content-center" />
                        </FormContainer>
                        {/* </form> */}
                    </div>
                    {/* <div className="tab-pane fade" id="pills-IOS" role="tabpanel" aria-labelledby="pills-IOS-tab" tabindex="0">
                    <form className="apps-form" onSubmit={handleSubmitIOS}>
                            <div className="w-100">
                                <div className="">
                                    <div className="form-field">
                                        <div className="mt-2">
                                            <h4 className="field-title">APP NAME</h4>
                                            <input
                                                className="apps-input"
                                                type="text"
                                                name="app_name"
                                                placeholder="Enter App Name"
                                                required
                                            />
                                        </div>
                                        <div className="mt-2">
                                            <h4 className="field-title">PACKAGE NAME</h4>
                                            <input
                                                className="apps-input"
                                                type="text"
                                                name="package_name"
                                                placeholder="Enter Package Name"
                                                required
                                            />
                                        </div>
                                        <div className="mt-2">
                                            <h4 className="field-title">API URL</h4>
                                            <input
                                                className="apps-input"
                                                type="url"
                                                name="api_url"
                                                placeholder="Enter API URL"
                                                required
                                            />
                                        </div>
                                        <div className="mt-2">
                                            <h4 className="field-title">APP ICON</h4>
                                            <input
                                                className="apps-input"
                                                type="file"
                                                name="app_icon"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <button className="apps-submit button-bg-color  theme-button-text-color admin-button-text  rounded-3  py-2 px-3 " type="submit" >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>

                        <div className="card p-2 mt-4">
                            <div className="py-2">
                                <h3 className="apps-header">Apps Table</h3>
                                <table className="apps-table ">
                                    <thead className="apps-table-head button-bg-color  theme-button-text-color admin-button-text  rounded-3  py-2 px-3 ">
                                        <tr className="apps-table-row">
                                            <th className="apps-table-header-cell">APP NAMES</th>
                                            <th className="apps-table-header-cell">CREATION DATE</th>
                                            <th className="apps-table-header-cell">DOWNLOAD</th>
                                        </tr>
                                    </thead>
                                    <tbody className="apps-table-body">
                                        {appMappings.map((mapping, index) => (
                                            <tr key={index} className="apps-table-body-row">
                                                <td className="apps-table-body-cell">{mapping.name}</td>
                                                <td className="apps-table-body-cell">{mapping.Date}</td>
                                                <td className="apps-table-body-cell">
                                                    <a
                                                        className="apps-table-download-link"
                                                        href={mapping.downloadUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"> Download </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* <form className="apps-form" onSubmit={handleSubmit}>
                    <div className="w-100">
                        <div className="">
                            <div className="form-field">
                                <div className="mt-2">
                                    <h4 className="field-title">APP NAME</h4>
                                    <input
                                        className="apps-input"
                                        type="text"
                                        name="app_name"
                                        placeholder="Enter App Name"
                                        required
                                    />
                                </div>
                                <div className="mt-2">
                                    <h4 className="field-title">PACKAGE NAME</h4>
                                    <input
                                        className="apps-input"
                                        type="text"
                                        name="package_name"
                                        placeholder="Enter Package Name"
                                        required
                                    />
                                </div>
                                <div className="mt-2">
                                    <h4 className="field-title">API URL</h4>
                                    <input
                                        className="apps-input"
                                        type="url"
                                        name="api_url"
                                        placeholder="Enter API URL"
                                        required
                                    />
                                </div>
                                <div className="mt-2">
                                    <h4 className="field-title">APP ICON</h4>
                                    <input
                                        className="apps-input"
                                        type="file"
                                        name="app_icon"
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="mt-3">
                            <button className="apps-submit button-bg-color  theme-button-text-color admin-button-text  rounded-3  py-2 px-3 " type="submit" >
                                Submit
                            </button>
                        </div>
                    </div>
                </form>

                <div className="card p-2 mt-4">
                    <div className="py-2">
                        <h3 className="apps-header">Apps Table</h3>
                        <table className="apps-table ">
                            <thead className="apps-table-head button-bg-color  theme-button-text-color admin-button-text  rounded-3  py-2 px-3 ">
                                <tr className="apps-table-row">
                                    <th className="apps-table-header-cell">APP NAMES</th>
                                    <th className="apps-table-header-cell">CREATION DATE</th>
                                    <th className="apps-table-header-cell">DOWNLOAD</th>
                                </tr>
                            </thead>
                            <tbody className="apps-table-body">
                                {appMappings.map((mapping, index) => (
                                    <tr key={index} className="apps-table-body-row">
                                        <td className="apps-table-body-cell">{mapping.name}</td>
                                        <td className="apps-table-body-cell">{mapping.Date}</td>
                                        <td className="apps-table-body-cell">
                                            <a
                                                className="apps-table-download-link"
                                                href={mapping.downloadUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"> Download </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div> */}

                <div className="card p-3 mt-4 shadow-sm">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <h4 className="admin-title mb-0 theme-text-color">
                            <FaBoxOpen className="me-2" />
                            App Builds
                        </h4>
                        <span className="badge bg-secondary">
                            Total: {appMappings.length}
                        </span>
                    </div>

                    <div className="table-responsive">
                        <table className="table align-middle table-hover apps-modern-table">
                            <thead className="table-light">
                                <tr>
                                    <th>App</th>
                                    <th>Version</th>
                                    <th>Build</th>
                                    <th>Type</th>
                                    <th>Created</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {appMappings.length > 0 ? (
                                    appMappings.map((mapping, index) => {
                                        const isRelease = Number(mapping.appformat) === 1;

                                        return (
                                            <tr key={index}>
                                                {/* App Info */}
                                                <td>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <img
                                                            src={mapping.app_icon}
                                                            alt={mapping.app_name}
                                                            className="app-icon"
                                                        />
                                                        <div>
                                                            <div className="fw-semibold">
                                                                {mapping.app_name}
                                                            </div>
                                                            <small className="text-muted">
                                                                {mapping.client || "—"}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Version */}
                                                <td>
                                                    {mapping.version_name ? (
                                                        <>
                                                            v{mapping.version_name}
                                                            <small className="text-muted d-block">
                                                                Code: {mapping.version_code}
                                                            </small>
                                                        </>
                                                    ) : (
                                                        <span className="text-muted">—</span>
                                                    )}
                                                </td>

                                                {/* Build Type (Debug / Release) */}
                                                <td>
                                                    {isRelease ? (
                                                        <span className="badge bg-success-subtle text-success">
                                                            <FaCheckCircle className="me-1" />
                                                            Release APK
                                                        </span>
                                                    ) : (
                                                        <span className="badge bg-warning-subtle text-warning">
                                                            <FaBug className="me-1" />
                                                            Debug APK
                                                        </span>
                                                    )}
                                                </td>

                                                {/* Platform */}
                                                <td>
                                                    <span className="badge bg-success-subtle text-success">
                                                        <FaAndroid className="me-1" />
                                                        {mapping.apk_build_type}
                                                    </span>
                                                </td>

                                                {/* Date */}
                                                <td>
                                                    <span className="text-muted">
                                                        {mapping.upload_on}
                                                    </span>
                                                </td>

                                                {/* Download */}
                                                <td className="text-center">
                                                    <button
                                                        className="btn btn-sm btn-primary d-inline-flex align-items-center gap-1"
                                                        onClick={() => {
                                                            const link = document.createElement("a");
                                                            link.href = mapping.build_url;
                                                            link.setAttribute("download", "");
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        }}
                                                    >
                                                        <FaDownload />
                                                        Download
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center text-muted py-4">
                                            No app builds found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </>
    );
}

export default Apps;
